import { BenchmarkCategory } from '@/api/generated-catch-backend/model';

/**
 * Maps benchmark categories to CSS class names for risk badge styling
 */
export const getRiskBadgeColor = (level: BenchmarkCategory): string => {
  switch (level) {
    case BenchmarkCategory.Above_average:
      return 'alert-error';
    case BenchmarkCategory.Average:
      return 'risk-badge-yellow';
    case BenchmarkCategory.Below_average:
      return 'alert-success';
    default:
      return 'risk-badge-yellow';
  }
};


/**
 * Generates risk text with population average information
 */
export const getRiskText = (level: BenchmarkCategory, popAverage: number): string => {
  const baseText = `Pop Avg ${popAverage}%`;
  switch (level) {
    case BenchmarkCategory.Above_average:
      return `**Above Average Risk** -\n ${baseText}`;
    case BenchmarkCategory.Average:
      return `**Average Risk** -\n ${baseText}`;
    case BenchmarkCategory.Below_average:
      return `**Below Average Risk** -\n ${baseText}`;
    default:
      return baseText;
  }
};